export function getExactDate(date = '') {
  const dt = date ? new Date(date) : new Date();
  const dtOnly = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
  return dtOnly;
}
